<template>
    <div>
        <edit-content-modal
            v-model="show_content1_dialog"
            :modelProp="contents.health_safety_1"
            :constants="constants"
        />

        <div class="tw-flex tw-flex-col tw-gap-4 tw-p-1">
            <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-4">
                <internal-table-section
                    section-title="Provincial Health & Safety"
                    button-text="Edit content"
                    @button-clicked="editContent1"
                    class="tw-w-full lg:tw-w-1/2"
                >
                    <v-card id="table_hs_content_card" class="d-flex flex-row container-fluid" flat>
                        <v-card-text class="pa-0 d-block">
                            <div class="px-7">
                                <v-layout child-flex>
                                    {{ $root.sanitizeAndTruncateHTML(contents.health_safety_1.body, 600) }}
                                </v-layout>
                            </div>
                        </v-card-text>
                    </v-card>
                </internal-table-section >
            </div>
        </div>
    </div>

</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import InternalHeader from "@/Generic/InternalHeader";
    import InternalTableSection from "@/Generic/InternalTableSection";
    import EditContentModal from "@/Modals/EditContentModal.vue";

    export default {
        name: "WebsiteContentHealthSafety",
        components: {
            EditContentModal,
            SmartTable,
            InternalHeader,
            InternalTableSection,
        },
        props: {
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'contents': {
                type: Object,
                required: false,
                default: function () {
                    return {}
                }
            },
        },
        data() {
            return {
                show_content1_dialog: false,
            }
        },
        mounted() {
            //
        },
        computed: {
            headersExample() {
                return [
                    {value: 'field_name',    text: 'Field Label',    align: `start`, sortable: false,   filterable: false,   search: null, optional: false },
                ]
            },
        },
        methods: {

            editContent1() {
                this.show_content1_dialog = true
            }
        }
    }
</script>
